/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout/ComponentWrap.vue'

const manage = {
  path: '/screen',
  component: Layout,
  redirect: '/screen/overview',
  name: 'Screen',
  hidden: true,
  meta: {
    title: 'screen'
  },
  children: [
    {
      path: 'overview',
      component: () => import('@/views/new-screen/page.vue'),
      name: 'Overview',
      meta: { title: 'overview' }
    }
  ]
}
export default manage
